
export default {
    name: 'HomeSlogan',
}
